module.exports = __webpack_public_path__ + "static/media/common_gem_small.c3cb9701.png";